<span class="loader" />

<style lang="css">
	.loader,
	.loader:before,
	.loader:after {
		border-radius: 50%;
		width: 2.1em;
		height: 2.1em;
		animation-fill-mode: both;
		animation: bblFadInOut 1.8s infinite ease-in-out;
	}
	.loader {
		display: inline-block;
		color: var(--color-highlight);
		font-size: 7px;
		position: relative;
		top: -2.1em;
		text-indent: -9999em;
		transform: translateZ(0);
		animation-delay: -0.16s;
		margin: 0 5em;
	}
	.loader:before,
	.loader:after {
		content: '';
		position: absolute;
		top: 0;
	}
	.loader:before {
		left: -3.5em;
		animation-delay: -0.32s;
	}
	.loader:after {
		left: 3.5em;
	}

	@keyframes bblFadInOut {
		0%,
		70%,
		100% {
			box-shadow: 0 2.1em 0 -1em;
		}
		40% {
			box-shadow: 0 2.1em 0 0;
		}
	}
</style>
